"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createPerformanceObserver = require("../utilities/createPerformanceObserver");

var _performance = require("../utilities/performance");

/**
 * A plugin responsible for measuring the cumulative layout shift score for a
 * page over time.
 *
 * This plugin adds the following parameters to the beacon:
 *
 * - `cumulativeLayoutShift`: an important, user-centric metric for measuring
 *   visual stability because it helps quantify how often users experience
 *   unexpected layout shifts — a low CLS helps ensure that the page is delightful.
 *
 * @see https://web.dev/cls/
 */
var createLayoutInstabilityPlugin = function createLayoutInstabilityPlugin() {
  return function (_ref) {
    var addVariable = _ref.addVariable,
        sendBeacon = _ref.sendBeacon;

    /**
     * This variable holds the Cumulative Layout Shift score.
     */
    var cls = 0;
    var lastCls;
    var observer;

    var handlePerformanceEntry = function handlePerformanceEntry(entry) {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        cls += entry.value;
      }
    };

    try {
      observer = (0, _createPerformanceObserver.createPerformanceObserver)(_performance.EntryType.LAYOUT_SHIFT, handlePerformanceEntry);
    } catch (error) {// Do nothing if the browser doesn't support this API.
    }

    return {
      pageDidDisappear: function pageDidDisappear(event) {
        if (observer != null) {
          observer.takeRecords().forEach(handlePerformanceEntry);

          if (event.unloading) {
            observer.disconnect();
          }

          if (lastCls !== cls) {
            addVariable('cumulativeLayoutShift', cls);
            sendBeacon();
          }

          lastCls = cls;
        }
      }
    };
  };
};

var _default = createLayoutInstabilityPlugin;
exports.default = _default;